<div class="modal-delete-factors">
  <div *ngIf="isLoading" class="modal-delete-factors__loader">
    <app-loading [onlyIcon]="true"></app-loading>
    {{ 'COMMONS.LOADING' | i18nextEager }}
  </div>
  <div class="modal-delete-factors__top-header">
    <div class="modal-delete-factors__title">
      <h2>{{ 'DELETE_FACTORS.TEXT' | i18nextEager }}</h2>
    </div>
    <span class="modal-delete-factors__click" (click)="closeDialog()">
      <img src="/assets/icons/close_modal.svg" alt="" />
    </span>
  </div>
  <span class="modal-delete-factors__description">{{ 'DELETE_FACTORS.DESCRIPTION' | i18nextEager }}</span>
  <div class="modal-delete-factors__enter">
    <button (click)="delete()">
      {{ 'DELETE_FACTORS.DELETE' | i18nextEager }}
    </button>
  </div>
</div>
